<template>
  <li class="breadcrumb-item" :class="{ active: active }"><slot></slot></li>
</template>
<script>
export default {
  name: 'breadcrumb-item',
  props: {
    active: {
      type: Boolean,
      default: false,
      description: 'Whether breadcrumb item is active'
    }
  }
};
</script>
<style scoped>
.breadcrumb-item {
  color: rgba(255,255,255,0.85);
  display: inline-flex;
  align-items: center;
}
/* Override global/Bootstrap default "/" separator */
.breadcrumb-item + .breadcrumb-item::before {
  content: '' !important;
}
.breadcrumb-item:not(:last-child)::after {
  content: '>';
  display: inline-block;
  margin: 0 8px;
  opacity: 0.8;
  color: var(--primary-color);
}
.breadcrumb-item.active,
.breadcrumb-item:last-child {
  font-weight: 700;
  color: #ffffff;
}
.breadcrumb-link {
  color: rgba(255,255,255,0.85);
  text-decoration: none;
}

.breadcrumb-current {
  color: var(--primary-color);
}
</style>
